// Calculates radius depending on current zoom level
const getSpaceRadius = ({ space, k, rScale, isOver, filtered }) => {
  const w = space.w < 10 ? 10 : space.w
  const maxR = Math.max(16, rScale(w / 2))
  let r = k * rScale(w / 2)

  if (r > maxR) {
    r = maxR
  }

  if (isOver) {
    r *= 1.5
  } else if (filtered) {
    r *= 0.8
  }

  return r
}

export default getSpaceRadius
